import Plyr from "plyr";

class AudioListPlayer {

    protected playerContainer = '.podcast-list-player';
    protected audioPlayer;
    protected currentTrack;

    constructor() {
        //$(document).on('click', '.podcast-list-player .podcasts-play-btn', this.playStop.bind(this));
        //$(document).on('click', '.js-play-audio', this.playStop.bind(this));
    }

    playStop(e) {
        let track = $(e.currentTarget).find('.btn-download').attr('href');
        console.log(track)

        if (this.currentTrack !== track)
            this.loadFile(track);

        if (this.audioPlayer.paused) {
            this.audioPlayer.play();
            $(e.currentTarget).addClass('_played');
        } else {
            this.audioPlayer.pause();
            $(e.currentTarget).removeClass('_played');
        }
    }

    loadFile(track) {
        $('.js-audio').html(
            new Audio(track)
        );

        $('.podcasts__last-item').removeClass('_played');

        if (this.audioPlayer) {
            this.audioPlayer.destroy();
        }

        this.audioPlayer = new Plyr('.js-audio audio', {
            debug: false,
            controls: []
        });

        this.currentTrack = track
    }


}

export default AudioListPlayer;
